const digitsOnly = (value) => String(value || "").replace(/\D+/g, "");

export const PUBLIC_BOOKING_PHONE_COUNTRIES = Object.freeze([
  Object.freeze({ code: "IN", name: "India", dialCode: "+91", flag: "🇮🇳" }),
  Object.freeze({ code: "NP", name: "Nepal", dialCode: "+977", flag: "🇳🇵" }),
  Object.freeze({ code: "SA", name: "Saudi Arabia", dialCode: "+966", flag: "🇸🇦" }),
  Object.freeze({ code: "AE", name: "United Arab Emirates", dialCode: "+971", flag: "🇦🇪" }),
]);

const COUNTRY_ALIASES = Object.freeze({
  IN: "IN",
  IND: "IN",
  INDIA: "IN",
  BHARAT: "IN",
  NP: "NP",
  NPL: "NP",
  NEPAL: "NP",
  SA: "SA",
  SAU: "SA",
  KSA: "SA",
  SAUDI: "SA",
  "SAUDI ARABIA": "SA",
  AE: "AE",
  ARE: "AE",
  UAE: "AE",
  "UNITED ARAB EMIRATES": "AE",
});

export const normalizePublicBookingCountryCode = (value) =>
  COUNTRY_ALIASES[String(value || "").trim().toUpperCase()] || "";

export const getPublicBookingPhoneCountry = (countryCode) =>
  PUBLIC_BOOKING_PHONE_COUNTRIES.find(
    (country) => country.code === normalizePublicBookingCountryCode(countryCode),
  ) || null;

export const resolvePublicBookingPhoneCountryCode = (venue) => {
  const venueDialDigits = digitsOnly(venue?.contact?.dialCode);

  if (venueDialDigits) {
    const matchedByDial = PUBLIC_BOOKING_PHONE_COUNTRIES.find(
      (country) => digitsOnly(country.dialCode) === venueDialDigits,
    );

    if (matchedByDial) return matchedByDial.code;
  }

  const venueCountryCode = normalizePublicBookingCountryCode(
    venue?.contact?.countryCode || venue?.country || venue?.location?.country,
  );

  return venueCountryCode || PUBLIC_BOOKING_PHONE_COUNTRIES[0].code;
};

export const normalizePublicBookingNationalNumber = (value, countryCode) => {
  const raw = String(value || "").trim();
  const phoneDigits = digitsOnly(raw);
  if (!phoneDigits) return "";

  const country = getPublicBookingPhoneCountry(countryCode);
  const dialDigits = digitsOnly(country?.dialCode);

  // A leading + makes the user's intent unambiguous: they pasted a full
  // international number. Strip only that selected prefix so the input state
  // remains the national number expected by the public-booking API.
  if (
    raw.startsWith("+") &&
    dialDigits &&
    phoneDigits.startsWith(dialDigits)
  ) {
    return phoneDigits.slice(dialDigits.length);
  }

  return phoneDigits;
};

export const buildPublicBookingContactNumber = (nationalNumber, countryCode) => {
  const phoneDigits = digitsOnly(nationalNumber);
  if (!phoneDigits) return "";

  const country = getPublicBookingPhoneCountry(countryCode);
  const dialDigits = digitsOnly(country?.dialCode);

  return dialDigits ? `${dialDigits}${phoneDigits}` : phoneDigits;
};

export const isValidPublicBookingNationalNumber = (value) =>
  /^[1-9]\d{5,10}$/.test(digitsOnly(value));

export const isValidPublicBookingContactNumber = (value) =>
  /^[1-9]\d{6,14}$/.test(digitsOnly(value));
